
import React from 'react';
import { Button } from '@/components/ui/button';

interface TerraceActionButtonsProps {
  website?: string;
  phone?: string;
}

const TerraceActionButtons = ({ website, phone }: TerraceActionButtonsProps) => {
  if (!website && !phone) return null;

  return (
    <div className="flex flex-col sm:flex-row gap-2">
      {website && (
        <Button 
          variant="default" 
          className="w-full sm:w-auto" 
          onClick={() => window.open(website, '_blank')}
        >
          Visit Website
        </Button>
      )}
      
      {phone && (
        <Button 
          variant="outline" 
          className="w-full sm:w-auto" 
          onClick={() => window.open(`tel:${phone}`)}
        >
          Call
        </Button>
      )}
    </div>
  );
};

export default TerraceActionButtons;
